import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { EventsService } from 'src/app/core/services/events.service';
import { AARouteEvents } from 'src/app/core/events/events';
import { AppRouterDataService } from '../../services/app-router-data/app-router-data.service';
import { AARouterURL } from '../../enums/routing.enum';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class NavComponent implements OnInit, OnDestroy {

  public routeLink: AARouterURL = AARouterURL.ROUTE_PLANNER;
  public trafficLink: AARouterURL = AARouterURL.TRAFFIC_NEWS;
  public mapLink: AARouterURL = AARouterURL.MAP_HOTELS;


  constructor(private eventsService: EventsService,
    private cdr: ChangeDetectorRef,
    private appRouterDataService: AppRouterDataService) { }

  ngOnInit() {
    this.eventsService.on(AARouteEvents.ROUTE_READY, this.onReady);
  }

  ngOnDestroy(): void {
    this.eventsService.remove(AARouteEvents.ROUTE_READY, this.onReady);
  }

  private onReady = (event) => {
    setTimeout( () => {
      this.cdr.detectChanges();
    }, 10);
  }

  get routeQueryParams(): any {
    return this.appRouterDataService.routePlanerLink;
  }

  get trafficNewsLink(): Array<any> {
    return this.appRouterDataService.trafficNewsLink();
  }

  get mapsHotelsLink(): Array<any> {
    return this.appRouterDataService.mapsHotelsLink();
  }

  getClick(clickedItem) {
    this.appRouterDataService.updateURL(clickedItem);
  }
}





